var LayoutGap;
(function (LayoutGap) {
    LayoutGap["LARGE"] = "32px";
    LayoutGap["MEDIUM"] = "24px";
    LayoutGap["NONE"] = "0";
    LayoutGap["SMALL"] = "16px";
    LayoutGap["XLARGE"] = "64px";
    LayoutGap["XSMALL"] = "8px";
    LayoutGap["XXSMALL"] = "4px";
})(LayoutGap || (LayoutGap = {}));
export default LayoutGap;
//# sourceMappingURL=layout-gap.js.map